<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm/usuarios">Empresas</router-link>
          </li>
          <li class="breadcrumb-item active">Criar Empresa</li>
        </ol> 

        <!-- Dados usuário-->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações da Empresa
            </h2>
          </div>
          <div class="row">
            <!-- <div class="col-md-3">
              <div class="form-group">
                <label>Criação</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="usuario.created_at"
                />
              </div>
            </div> -->
            <div class="col-md-3">
              <div class="form-group">
                <label>E-mail</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="empresa.email"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="empresa.nome"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CNPJ</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="empresa.cnpj"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Telefone</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="empresa.telefone"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Quantidade de funcionários</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="empresa.qtd_funcionarios"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Plano</label>
                <select
                class="form-control"
                v-model="empresa.plans_id"
                >
                  <option v-for="plan in planos" :key="plan.id" :value="plan.id">
                    {{ plan.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p>
                <button href="#0" class="btn_1 medium pull-right" @click="salvaEstabelecimento()">Salvar</button>
              </p>
            </div>
          </div>
        </div>

        <!-- Dados Subscriber-->
       <!--  <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações do Subscriber
            </h2>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Aniversário</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subscriber.birth_date"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CPF</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subscriber.cpf"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>RG</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subscriber.rg"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CEP</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.zip_code"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Estado</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.state"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Cidade</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.city"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Rua</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.street"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.district"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Número da residência</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.street_number"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Código de Área</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="phone.area_code"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Número de telefone</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="phone.number"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Complemento</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.complement"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p>
                <button href="#0" class="btn_1 medium pull-right" @click="salvaEstabelecimento()">Salvar</button>
              </p>
            </div>
          </div> 
        </div>-->
      </div> <!-- /container-fluid-->
    </div> 
    </div> 
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import { VueEditor } from "vue2-editor";
import { Money } from "v-money";
import {Loader, LoaderOptions} from 'google-maps';
import { cnpj } from 'cpf-cnpj-validator';

export default {
  components: {
    VueEditor,
    Money
  },
  mixins: [funcoesGerais],
  data() {
    return {
      empresa: {},
      subscriber: {},
      phone: {},
      isLoading: false,
      aprovacao: false,
      planos:[],
    };
  },
  mounted() { 
    let self = this;
    self.isLoading = true;
    ajax(
      "get",
      "planos"
    )
    .then(res=>{
      this.planos=res
      self.isLoading = false;
    })
  },
  methods: {
    salvaEstabelecimento() {
      let self = this;
      self.isLoading = true;
      const cnpjValidate = cnpj.isValid(self.empresa.cnpj);
      if(cnpjValidate){
        ajax("post", "empresas",self.empresa)
        .then(response => {
          self.isLoading = false;
          alerta(
            "success",
            "Sucesso",
            "Usuário cadastrado com sucesso!"
          );
          self.$router.replace(this.$route.query.redirect || "/adm/empresas");
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
      }else{
        let erros = {};
        if (!cnpjValidate) erros.cnpj = ["CNPJ invalido"];
        alerta("warning", "Atenção", ReturnStringErrorByArrayOfErrors(erros));
      }
    },
    getPlanos(){
      ajax("get","planos")
        .then(res=>{
          this.planos=res.data
        })
    }
  },
};
</script>

<style scoped>
.input-horario {
  width: 50px;
  border: blue;
}

#map{
  width: 100%;
}

</style>